var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from "@mui/material";
import { useState, useEffect, useMemo } from "react";
import Dropzone from "react-dropzone";
import ImageIcon from "@mui/icons-material/Image";
import Text from "../../Atoms/Text";
import { dragAndDropSxPropsFn, textStyles, imageUploadCTAStyles, } from "./ImageUpload.styles";
import { readFileAsDataUrl } from "../../../helpers";
import { COLORS } from "../../../constants";
var ImageUpload = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.size, size = _b === void 0 ? "medium" : _b, uploadCallback = _a.uploadCallback, description = _a.description, _c = _a.accept, accept = _c === void 0 ? {
        "image/*": [".png", ".jpeg", ".jpg"],
    } : _c, controlled = _a.controlled, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.circularCrop, circularCrop = _e === void 0 ? false : _e;
    var _f = __read(useState(null), 2), image = _f[0], setImage = _f[1];
    var _g = __read(useState(""), 2), imageUrl = _g[0], setImageUrl = _g[1];
    useEffect(function () {
        setImageUrl(value || "");
    }, [value]);
    useEffect(function () {
        if (image && !controlled) {
            // this just creates a DOMString with a URL so you can render the image
            if (typeof image === "object") {
                setImageUrl(URL.createObjectURL(image));
            }
        }
    }, [image]);
    // callback to handle file upload via Dropzone component
    // their API supports dropping in multiple files but for this component,
    // so we disregard anything but the first file in the list.
    var onDrop = function (acceptedFiles) { return __awaiter(void 0, void 0, void 0, function () {
        var imageFile;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!acceptedFiles.length) {
                        return [2 /*return*/];
                    }
                    imageFile = acceptedFiles[0];
                    setImage(imageFile);
                    if (onChange) {
                        onChange({ imgFile: imageFile, imgUrl: URL.createObjectURL(imageFile) });
                    }
                    // ImageUploadAndCrop expects an image as a dataURL read by a FileReader
                    // to be passed in for cropping, in the future if we need the callback to send
                    // something else, we could make a separate callback method just for ImageUploadAndCrop
                    return [4 /*yield*/, readFileAsDataUrl(imageFile).then(function (url) {
                            if (uploadCallback) {
                                uploadCallback(url);
                            }
                        })];
                case 1:
                    // ImageUploadAndCrop expects an image as a dataURL read by a FileReader
                    // to be passed in for cropping, in the future if we need the callback to send
                    // something else, we could make a separate callback method just for ImageUploadAndCrop
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getInnerContent = function () {
        if (imageUrl) {
            return (_jsxs(_Fragment, { children: [_jsx("img", { "data-testid": "uploaded-image", src: imageUrl, style: {
                            width: "100%",
                            height: "100%",
                            objectFit: circularCrop ? "cover" : "contain",
                            borderRadius: circularCrop ? "50%" : "0",
                        } }), _jsx(Stack, __assign({ className: "image-upload-hover-cta", sx: imageUploadCTAStyles, borderRadius: circularCrop ? "50%" : 2 }, { children: _jsx(Text, __assign({ variant: "body3", sx: textStyles, category: "onsurface" }, { children: size === "small" ? "Replace" : "Replace Image" })) }))] }));
        }
        else {
            return (_jsxs(_Fragment, { children: [_jsx(ImageIcon, { style: { color: disabled ? COLORS.P_DISABLED : COLORS.BLACK } }), _jsx(Text, __assign({ variant: "caption", sx: textStyles }, { children: "Add Image" }))] }));
        }
    };
    var dragDropStyles = useMemo(function () {
        return dragAndDropSxPropsFn({
            displayImageUrl: imageUrl,
            size: size,
            disabled: disabled,
            circularCrop: circularCrop,
        });
    }, [imageUrl, size, disabled, circularCrop]);
    return (_jsxs(Stack, __assign({ borderRadius: circularCrop ? "50%" : 2 }, { children: [_jsx(Dropzone, __assign({ onDrop: onDrop, disabled: disabled, accept: accept }, { children: function (_a) {
                    var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps;
                    return (_jsxs(Stack, __assign({}, getRootProps(), { sx: dragDropStyles }, { children: [_jsx("input", __assign({}, getInputProps(), { "data-testid": "drop-input" })), getInnerContent(), _jsx(Box, { width: "calc(100%)", height: "calc(100%)", border: "2px dashed ".concat(COLORS.P_OUTLINE), position: "absolute", top: 0, borderRadius: circularCrop ? "50%" : 2, left: 0 })] })));
                } })), description && (_jsx(Text, __assign({ sx: { mt: 3 }, variant: "caption", emphasis: "medium" }, { children: description })))] })));
};
export default ImageUpload;
